import { createFileRoute } from '@tanstack/react-router';
import { Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/')({
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermissionToResource, isInternalRole },
    } = context;
    const isAllowed =
      isInternalRole || hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.MEASUREMENT, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
